export default __webpack_public_path__ + "static/media/icon_perfect.7bae14a5.svg";